var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.user_edit") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutters" },
            [_c("back-button", { staticClass: "btnFilter_2" })],
            1
          ),
          _vm._v(" "),
          _vm.activateSpinner
            ? _c("spinner")
            : _c(
                "form-accordion",
                {
                  attrs: {
                    isTitleUpperCase: false,
                    title: _vm.$t("administration.user"),
                  },
                },
                [
                  _c("div", { staticClass: "form-group" }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "ml-2 mr-2" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t("administration.login"),
                              placeholderValue: _vm.$t("administration.login"),
                            },
                            model: {
                              value: _vm.login,
                              callback: function ($$v) {
                                _vm.login = $$v
                              },
                              expression: "login",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t("administration.name"),
                              placeholderValue: _vm.$t("administration.name"),
                            },
                            model: {
                              value: _vm.name,
                              callback: function ($$v) {
                                _vm.name = $$v
                              },
                              expression: "name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "ml-2 mr-2" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("administration.active")) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.active,
                                  expression: "active",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { id: "sel4", readonly: "" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.active = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "0" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("administration.no")) +
                                    " "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "2" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("administration.yes")) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", [_vm._v(_vm._s(_vm.$t("common.pwd")))]),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex" }, [
                            _vm.passwordType === "checkbox"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.password)
                                      ? _vm._i(_vm.password, null) > -1
                                      : _vm.password,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.password,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.password = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.password = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.password = $$c
                                      }
                                    },
                                  },
                                })
                              : _vm.passwordType === "radio"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: { type: "radio" },
                                  domProps: {
                                    checked: _vm._q(_vm.password, null),
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.password = null
                                    },
                                  },
                                })
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: { type: _vm.passwordType },
                                  domProps: { value: _vm.password },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.password = $event.target.value
                                    },
                                  },
                                }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "icon icon-password mt-2 pt-1 icon-field",
                              class: [
                                _vm.isPasswordFieldHidden
                                  ? "fa-duotone fa-eye"
                                  : "fa-duotone fa-eye-slash",
                              ],
                              on: { click: _vm.switchPasswordType },
                            }),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "ml-2 mr-2" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("common.security.verif_password"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex" }, [
                            _vm.passwordVerifType === "checkbox"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.passwordVerif,
                                      expression: "passwordVerif",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.passwordVerif)
                                      ? _vm._i(_vm.passwordVerif, null) > -1
                                      : _vm.passwordVerif,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.passwordVerif,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.passwordVerif = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.passwordVerif = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.passwordVerif = $$c
                                      }
                                    },
                                  },
                                })
                              : _vm.passwordVerifType === "radio"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.passwordVerif,
                                      expression: "passwordVerif",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: { type: "radio" },
                                  domProps: {
                                    checked: _vm._q(_vm.passwordVerif, null),
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.passwordVerif = null
                                    },
                                  },
                                })
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.passwordVerif,
                                      expression: "passwordVerif",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: { type: _vm.passwordVerifType },
                                  domProps: { value: _vm.passwordVerif },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.passwordVerif = $event.target.value
                                    },
                                  },
                                }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "icon icon-password mt-2 pt-1 icon-field",
                              class: [
                                _vm.isPasswordVerifFieldHidden
                                  ? "fa-duotone fa-eye"
                                  : "fa-duotone fa-eye-slash",
                              ],
                              on: { click: _vm.switchPasswordVerifType },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "form-group",
                          attrs: { cols: "6", sm: "6" },
                        },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: {
                                value: "1",
                                "unchecked-value": "0",
                                disabled: _vm.receivedFirstLogin,
                              },
                              model: {
                                value: _vm.firstLogin,
                                callback: function ($$v) {
                                  _vm.firstLogin = $$v
                                },
                                expression: "firstLogin",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.receivedFirstLogin
                                      ? _vm.$t(
                                          "administration.reset_password_option"
                                        ) +
                                          " " +
                                          _vm.$t("common.active_par")
                                      : _vm.$t(
                                          "administration.reset_password_option"
                                        )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-start ml-2 mr-2" },
                    [
                      _vm.isNormSRTP
                        ? _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  model: {
                                    value: _vm.srtpNorm,
                                    callback: function ($$v) {
                                      _vm.srtpNorm = $$v
                                    },
                                    expression: "srtpNorm",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.norm_SRTP")))]
                              ),
                              _vm._v(" "),
                              _vm.srtpNorm
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "px-0",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "combo-list-field d-flex justify-content-between",
                                          attrs: {
                                            id: "profile-picker-link-srtp",
                                            href: "#",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                "fixed-span-size " +
                                                (_vm.profileDisplaySRTP.nb > 0
                                                  ? "filter-item-input-complete"
                                                  : ""),
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.profileDisplaySRTP.label
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "fa-light fa-chevron-down",
                                            attrs: {
                                              size: "17px",
                                              id: "status-chevron",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-popover",
                                        {
                                          attrs: {
                                            target: "profile-picker-link-srtp",
                                            title: _vm.$t(
                                              "administration.select_profile"
                                            ),
                                            triggers: "focus",
                                            placement: "bottom",
                                          },
                                        },
                                        _vm._l(
                                          _vm.SRTPProfiles,
                                          function (profile, index) {
                                            return _c(
                                              "span",
                                              {
                                                key:
                                                  "filtered-profile-" +
                                                  profile.id_rights_profile +
                                                  "-" +
                                                  index,
                                              },
                                              [
                                                _c(
                                                  "b-form-checkbox",
                                                  {
                                                    attrs: {
                                                      value: 1,
                                                      "unchecked-value": 0,
                                                    },
                                                    model: {
                                                      value: profile.state,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          profile,
                                                          "state",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "profile.state",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .$t(
                                                              "rights.db_profiles." +
                                                                profile.libelle
                                                            )
                                                            .slice(0, -4)
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isNormHRTP
                        ? _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  model: {
                                    value: _vm.hrtpNorm,
                                    callback: function ($$v) {
                                      _vm.hrtpNorm = $$v
                                    },
                                    expression: "hrtpNorm",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.norm_HRTP")))]
                              ),
                              _vm._v(" "),
                              _vm.hrtpNorm
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "px-0",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "combo-list-field d-flex justify-content-between",
                                          attrs: {
                                            id: "profile-picker-link-hrtp",
                                            href: "#",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                "fixed-span-size " +
                                                (_vm.profileDisplayHRTP.nb > 0
                                                  ? "filter-item-input-complete"
                                                  : ""),
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.profileDisplayHRTP.label
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "fa-light fa-chevron-down",
                                            attrs: {
                                              size: "17px",
                                              id: "status-chevron",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-popover",
                                        {
                                          attrs: {
                                            target: "profile-picker-link-hrtp",
                                            title: _vm.$t(
                                              "administration.select_profile"
                                            ),
                                            triggers: "focus",
                                            placement: "bottom",
                                          },
                                        },
                                        _vm._l(
                                          _vm.HRTPProfiles,
                                          function (profile, index) {
                                            return _c(
                                              "span",
                                              {
                                                key:
                                                  "filtered-profile-" +
                                                  profile.id_rights_profile +
                                                  "-" +
                                                  index,
                                              },
                                              [
                                                _c(
                                                  "b-form-checkbox",
                                                  {
                                                    attrs: {
                                                      value: 1,
                                                      "unchecked-value": 0,
                                                    },
                                                    model: {
                                                      value: profile.state,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          profile,
                                                          "state",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "profile.state",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .$t(
                                                              "rights.db_profiles." +
                                                                profile.libelle
                                                            )
                                                            .slice(0, -5)
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isNormPSD2
                        ? _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  model: {
                                    value: _vm.psd2Norm,
                                    callback: function ($$v) {
                                      _vm.psd2Norm = $$v
                                    },
                                    expression: "psd2Norm",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.norm_PSD2")))]
                              ),
                              _vm._v(" "),
                              _vm.psd2Norm
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "px-0",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "combo-list-field d-flex justify-content-between",
                                          attrs: {
                                            id: "profile-picker-link-psd2",
                                            href: "#",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                "fixed-span-size " +
                                                (_vm.profileDisplayPSD2.nb > 0
                                                  ? "filter-item-input-complete"
                                                  : ""),
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.profileDisplayPSD2.label
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "fa-light fa-chevron-down",
                                            attrs: {
                                              size: "17px",
                                              id: "status-chevron",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-popover",
                                        {
                                          attrs: {
                                            target: "profile-picker-link-psd2",
                                            title: _vm.$t(
                                              "administration.select_profile"
                                            ),
                                            triggers: "focus",
                                            placement: "bottom",
                                          },
                                        },
                                        _vm._l(
                                          _vm.PSD2Profiles,
                                          function (profile, index) {
                                            return _c(
                                              "span",
                                              {
                                                key:
                                                  "filtered-profile-" +
                                                  profile.id_rights_profile +
                                                  "-" +
                                                  index,
                                              },
                                              [
                                                _c(
                                                  "b-form-checkbox",
                                                  {
                                                    attrs: {
                                                      value: 1,
                                                      "unchecked-value": 0,
                                                    },
                                                    model: {
                                                      value: profile.state,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          profile,
                                                          "state",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "profile.state",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .$t(
                                                              "rights.db_profiles." +
                                                                profile.libelle
                                                            )
                                                            .slice(0, -5)
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isNormNone
                        ? _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  model: {
                                    value: _vm.psd2Norm,
                                    callback: function ($$v) {
                                      _vm.psd2Norm = $$v
                                    },
                                    expression: "psd2Norm",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("administration.profile_edit")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.psd2Norm
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "px-0",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "combo-list-field d-flex justify-content-between",
                                          attrs: {
                                            id: "profile-picker-link-psd2",
                                            href: "#",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                "fixed-span-size " +
                                                (_vm.profileDisplayPSD2.nb > 0
                                                  ? "filter-item-input-complete"
                                                  : ""),
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.profileDisplayPSD2.label
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "fa-light fa-chevron-down",
                                            attrs: {
                                              size: "17px",
                                              id: "status-chevron",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-popover",
                                        {
                                          attrs: {
                                            target: "profile-picker-link-psd2",
                                            title: _vm.$t(
                                              "administration.select_profile"
                                            ),
                                            triggers: "focus",
                                            placement: "bottom",
                                          },
                                        },
                                        _vm._l(
                                          _vm.Profiles,
                                          function (profile, index) {
                                            return _c(
                                              "span",
                                              {
                                                key:
                                                  "filtered-profile-" +
                                                  profile.id_rights_profile +
                                                  "-" +
                                                  index,
                                              },
                                              [
                                                _c(
                                                  "b-form-checkbox",
                                                  {
                                                    attrs: {
                                                      value: 1,
                                                      "unchecked-value": 0,
                                                    },
                                                    model: {
                                                      value: profile.state,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          profile,
                                                          "state",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "profile.state",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(profile.libelle)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass:
                "accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters",
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter_2",
                  on: {
                    click: function ($event) {
                      return _vm.changeUser()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }